import { Injectable } from '@angular/core';
import {
  Firestore,
  doc,
  runTransaction
} from '@angular/fire/firestore';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable({ providedIn: 'root' })
export class RentalAssignmentService {
  constructor(private firestore: Firestore, private functions: Functions) {}

   async assignRentalToUser(rentalId: string, userId: string) {
    const callable = httpsCallable(this.functions, 'assignRentalToUser');
    const result = await callable({ rentalId, userId });
    return result.data;
  }
}
